import React from 'react';
import { SearchLayout } from '../search-layout';
import { TableLayout } from '../table-layout';
export const PageLayout = ({ searchLayout, tableLayout, content, action }) => {
  return (
    <>
      {searchLayout && <SearchLayout props={{ ...searchLayout }} />}
      {content}
      {tableLayout && <TableLayout props={{ ...tableLayout }} />}
      {action}
    </>
  );
};
